import {NgControl} from '@angular/forms';
import {FormErrorMessagesMapper} from '@shared/modules/form/common/constants/form-error-messages.const';
import {AnyObject} from '@shared/interfaces/objects.interface';

export abstract class AbstractFormControlValidator {
  protected constructor(public ngControl: NgControl) { }

  get hasErrors(): boolean {
    return this.ngControl.control.touched && !!this.ngControl.control.errors;
  }

  getApiError(): string {
    const errors: AnyObject = this.ngControl.control.errors || {};
    return errors.api;
  }

  getValidatorError(): string {
    const errors: AnyObject = this.ngControl.control.errors || {};
    const key: string = Object.keys(errors)[0];

    return FormErrorMessagesMapper[key] || 'Pole jest nieprawidłowo wypełnione.';
  }
}
